export function cleanSearchValue(value, removeLeadingZeros = false) {
    if (!value)
        return '';
    const cleanedValue = value
        // .replace(
        //     /[^a-zA-Z0-9аАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ]+/g,
        //     ''
        // )
        .toUpperCase();
    if (removeLeadingZeros) {
        return cleanedValue.replace(/^0+/, '');
    }
    return cleanedValue;
}
export function cleanSearchValueForOrderFilter(value, removeLeadingZeros = false) {
    if (!value)
        return '';
    const cleanedValue = value
        .replace(/[^a-zA-Z0-9аАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ]+/g, '')
        .toUpperCase();
    if (removeLeadingZeros) {
        return cleanedValue.replace(/^0+/, '');
    }
    return cleanedValue;
}
